import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import GuestMask from './guestMask';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import Observer from '@researchgate/react-intersection-observer';
import IntersectionObserver from 'intersection-observer-polyfill';

let isFirstExposure = false;

// 酒瓶特效
const Bottle = ({ brandWinePic, isBottlePositionLeft }) => {
    const [isShowBottle, setIsShowBottle] = useState(false);
    const bottleRef = useRef(null);

    useEffect(() => {
        const bottleDom = bottleRef.current;
        const bottleHeight = bottleDom.offsetHeight;
        const windowHeight = window.innerHeight;
        let flag = true;

        window.addEventListener('scroll', () => {
            // 判断bottleRef是否完全在可是窗口

            if (bottleDom.getBoundingClientRect().top + bottleHeight <= windowHeight && flag) {
                flag = false;
                setIsShowBottle(true);
            }
            if (bottleDom.getBoundingClientRect().top + bottleHeight > windowHeight && !flag) {
                flag = true;
                setIsShowBottle(false);
            }
        });

        setTimeout(() => {
            isFirstExposure = true;
        }, 1000);
    }, []);

    return brandWinePic?.whitePic ? (
        <div className={`${styles.guestBottle} ${isShowBottle ? styles.botteleAnimation : ''} ${isBottlePositionLeft ? styles.bottlePositionLeft : styles.bottlePositionRight}`} ref={bottleRef}>
            <img className={styles.guestBottleLeft} src={brandWinePic?.whitePic} alt="" />
            <img className={styles.guestBottleRight} src={brandWinePic?.goldenPic} alt="" />
        </div>
    ) : null;
};

Bottle.propTypes = {
    brandWinePic: PropTypes.object,
    isBottlePositionLeft: PropTypes.bool,
};

// 嘉宾背景
const GuestItem = ({ item, index, setNavIndex, guestMaskItemData, onChangeCurrentVideo, onChangeMaskVisible, brandWinePic, isBottlePositionLeft }) => {
    const [isGuestMask, setIsGuestMask] = useState(false);
    const guestRef = useRef(null);
    // const getPrintableThreshold = (ratio, range) => range.reduce((prev, curr) => (Math.abs(curr - ratio) < Math.abs(prev - ratio) ? curr : prev));
    // const handleChange = ({ isIntersecting, intersectionRatio }) => {
    //     if (getPrintableThreshold(intersectionRatio.toFixed(2), [1]) === 1 && isFirstExposure) {
    //         setNavIndex(parseInt(index));
    //     }
    // };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio === 1 && isFirstExposure) {
                        const activeIndex = parseInt(entry.target.getAttribute('index'));

                        setNavIndex(activeIndex);
                    }
                    // console.log(entry.intersectionRatio === 1, entry.target.getAttribute('index'), '2222222');
                });
            },
            {
                threshold: [1],
            }
        );

        observer.observe(document.querySelector(`#guestBox_${index}`));
    });

    return (
        <>
            {/* <Observer onChange={handleChange} threshold={[1]} key={index}> */}
            <div
                className={styles.guestItem}
                index={index}
                ref={guestRef}
                id={`guestBox_${index}`}
                onClick={() => {
                    setIsGuestMask(true);
                }}>
                <img className={styles.guestItemBackground} src={item.userBackground} />
                <div className={styles.guestItemBox}>
                    <img className={styles.guestItemPic} src={item.userImage} />
                    <Bottle brandWinePic={brandWinePic} isBottlePositionLeft={isBottlePositionLeft} />
                </div>
            </div>
            {/* </Observer> */}
            {/* 嘉宾弹窗 */}
            {isGuestMask && <GuestMask guestMaskItemData={guestMaskItemData} setIsGuestMask={setIsGuestMask} onChangeCurrentVideo={onChangeCurrentVideo} onChangeMaskVisible={onChangeMaskVisible} />}
        </>
    );
};

GuestItem.propTypes = {
    brandWinePic: PropTypes.object,
    item: PropTypes.object,
    index: PropTypes.number,
    setNavIndex: PropTypes.func,
    guestMaskItemData: PropTypes.object,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    isBottlePositionLeft: PropTypes.bool,
};

const Guest = ({ content, setNavIndex, guestMaskData, onChangeCurrentVideo, onChangeMaskVisible, brandWinePic }) => {
    return (
        <div className={styles.guest}>
            {content.map((item, index) => {
                return (
                    <GuestItem
                        key={index}
                        item={item}
                        index={index}
                        setNavIndex={setNavIndex}
                        guestMaskItemData={guestMaskData[index]}
                        onChangeCurrentVideo={onChangeCurrentVideo}
                        onChangeMaskVisible={onChangeMaskVisible}
                        brandWinePic={brandWinePic}
                        isBottlePositionLeft={item.userIconPosition}
                    />
                );
            })}
        </div>
    );
};

Guest.propTypes = {
    brandWinePic: PropTypes.object,
    content: PropTypes.array,
    setNavIndex: PropTypes.func,
    guestMaskData: PropTypes.array,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
};

export default errorBoundary(Guest);
